import { createStyles, Theme } from "@material-ui/core";

export const styles = (theme: Theme) => createStyles({
  tableContainer: {
    marginBottom: theme.spacing(2),
    boxShadow: 'none',
    border: '1px solid rgba(224, 224, 224, 1)',
    borderRadius: '4px',
  },
  tableHead: {
    backgroundColor: theme.palette.grey[50],
  },
  headerCell: {
    fontWeight: 'bold',
  },
  sortableHeader: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
    },
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  clearOrderContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
  },
  clearOrderText: {
    marginLeft: theme.spacing(1),
  }
});